function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 4C22 6.20914 23.7909 8 26 8C27.0609 8 28.0783 7.57857 28.8284 6.82843C29.5786 6.07828 30 5.06087 30 4C30 1.79086 28.2091 0 26 0C23.7909 0 22 1.79086 22 4ZM24 4C24 2.89543 24.8954 2 26 2C26.5304 2 27.0391 2.21071 27.4142 2.58579C27.7893 2.96086 28 3.46957 28 4C28 5.10457 27.1046 6 26 6C24.8954 6 24 5.10457 24 4Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.896 32H27.096C28.1224 31.999 28.9814 31.2212 29.084 30.2L29.904 22H31C31.2835 22.0014 31.5543 21.8825 31.745 21.6727C31.9357 21.4629 32.0284 21.1821 32 20.9L31.084 11.8C30.9814 10.7788 30.1224 10.001 29.096 10H28C27.7343 10.0001 27.4796 10.1058 27.292 10.294L26 11.586L24.708 10.292C24.5201 10.1046 24.2654 9.99953 24 10H22.898C21.8716 10.001 21.0126 10.7788 20.91 11.8L20 20.9C19.9717 21.1821 20.0644 21.4629 20.2551 21.6727C20.4458 21.8825 20.7165 22.0014 21 22H22.088L22.908 30.2C23.0106 31.2212 23.8696 31.999 24.896 32ZM23 20H22.096L22.904 12H23.586L25.29 13.708C25.6805 14.0984 26.3135 14.0984 26.704 13.708L28.412 12H29.094L29.894 20H29C28.4845 19.9974 28.0516 20.3871 28 20.9L27.104 30H24.904L24 20.9C23.9485 20.3871 23.5155 19.9974 23 20Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 32H7C7.55228 32 8 31.5523 8 31V21C8 20.4477 7.55228 20 7 20H1C0.447715 20 0 20.4477 0 21V31C0 31.5523 0.447715 32 1 32ZM6 30H2V22H6V30Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 32H17C17.5523 32 18 31.5523 18 31V11C18 10.4477 17.5523 10 17 10H11C10.4477 10 10 10.4477 10 11V31C10 31.5523 10.4477 32 11 32ZM16 30H12V12H16V30Z",
  fill: "#32D882"
});

var SvgVenueManagment9 = function SvgVenueManagment9(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment9, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment9.66bae999.svg";
export { ForwardRef as ReactComponent };